export interface TenantFrontendRoute {
  /** Optional tenant id matching a TENANT_CONFIGS entry (e.g. "balgores", "marquis"). */
  tenantId?: string | null;
  advisorFrontendUrl: string;
  clientFrontendUrl: string;
  apiOrigin: string;
  /** Optional brand id applied when neither the API nor TENANT_CONFIGS specifies a brand. */
  brandId?: string | null;
}

export interface ApiUrls {
  apiUrl: string;
  rawApiUrl: string;
}

export function resolveFrontendRoutes(
  frontendOrigin: string,
  tenantRoutes: readonly TenantFrontendRoute[]
): TenantFrontendRoute {
  const normalizedOrigin = normalizeOrigin(frontendOrigin);
  const matches = tenantRoutes.filter(
    (routes) =>
      normalizeOrigin(routes.advisorFrontendUrl) === normalizedOrigin ||
      normalizeOrigin(routes.clientFrontendUrl) === normalizedOrigin
  );
  if (matches.length !== 1) {
    throw new Error(`Expected one frontend route for origin "${normalizedOrigin}", found ${matches.length}`);
  }
  return matches[0];
}

export function apiUrlsFromOrigin(apiOrigin: string): ApiUrls {
  const origin = apiOrigin.trim().replace(/\/+$/, '');
  if (!origin) {
    throw new Error('An API origin is required');
  }
  return {
    apiUrl: `${origin}/`,
    rawApiUrl: `${origin}/_ah/api/`
  };
}

function normalizeOrigin(origin: string): string {
  return new URL(origin.trim()).origin.toLowerCase();
}
